var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13CFE8",
    d: "M10.014 3.875A1.745 1.745 0 0 0 7.941 2.86L4.09 3.91C3.329 4.12 2.8 4.811 2.8 5.6c0 10.824 8.776 19.6 19.6 19.6.788 0 1.479-.53 1.689-1.29l1.05-3.85a1.745 1.745 0 0 0-1.015-2.075l-4.2-1.75a1.74 1.74 0 0 0-2.026.508l-1.767 2.157a14.8 14.8 0 0 1-7.031-7.03l2.157-1.764c.6-.49.805-1.312.507-2.026l-1.75-4.2z"
  })));
};
export default SvgPhone;